import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import annTools from '../pdf/annotations/commonAnnotationTools';
import ColorSwatches from './colorSwatches';
const makeRGBASafe = color => ({
  key: annTools.parseColor(color).join('-'),
  string: annTools.parseColor(color).join(',')
});
const isTransparent = color => {
  const parsedColor = annTools.parseColor(color);
  return parsedColor[3] === 0; // alpha === 0
};
const getTransparentBackgroundStyle = () => ({
  backgroundImage: "\n    linear-gradient(45deg, #ccc 25%, transparent 25%),\n    linear-gradient(-45deg, #ccc 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, #ccc 75%),\n    linear-gradient(-45deg, transparent 75%, #ccc 75%)\n  ",
  backgroundSize: '12px 12px',
  backgroundPosition: '0 0, 0 6px, 6px -6px, -6px 0px'
});
export default class ColorSelectorModal extends Component {
  constructor(props) {
    super(props);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      showSelector: false
    };
  }
  showModal() {
    this.setState({
      showSelector: true
    });
  }
  hideModal() {
    this.setState({
      showSelector: false
    });
  }
  handleChange(color) {
    const onChange = this.props.onChange;
    onChange(color);
    this.hideModal();
  }
  showModalButtonProps(color) {
    const indicatorShape = this.props.indicatorShape;
    const rgbaSafeColor = makeRGBASafe(color);
    const style = {
      backgroundColor: "rgba(".concat(rgbaSafeColor.string, ")")
    };

    // Apply transparent background pattern if color is transparent
    if (isTransparent(color)) {
      Object.assign(style, getTransparentBackgroundStyle());
    }
    return {
      className: "t-csm-button-show-modal colorSelector".concat(indicatorShape === 'circle' ? 'Circle' : 'Rectangle'),
      key: "color-".concat(rgbaSafeColor.key),
      style,
      onClick: this.showModal
    };
  }
  buttonProps(color) {
    const selectedColor = this.props.selectedColor;
    const disabled = this.props.disabled;
    const rgbaSafeColor = makeRGBASafe(color);
    const style = {
      backgroundColor: "rgba(".concat(rgbaSafeColor.string, ")"),
      padding: '20px'
    };

    // Apply transparent background pattern if color is transparent
    if (isTransparent(color)) {
      Object.assign(style, getTransparentBackgroundStyle());
    }
    const propStyle = {
      disabled,
      className: "t-csm-button-set-color-".concat(rgbaSafeColor.key, " colorSelectorCircle"),
      key: "color-".concat(rgbaSafeColor.key),
      style,
      onClick: () => this.handleChange(color) // returns the original color (obj or string - 0-1)
    };
    // toSaveColor defaults to sending a string back, so compare the color strings
    if (annTools.toSaveColor(color) === annTools.toSaveColor(selectedColor)) {
      propStyle.style.WebkitBoxShadow = '0px 0px 4px 4px rgba(100,100,100,0.75)';
      propStyle.style.MozBoxShadow = '0px 0px 4px 4px rgba(100,100,100,0.75)';
      propStyle.style.boxShadow = '0px 0px 4px 4px rgba(100,100,100,0.75)';
      propStyle.className += ' active';
    }
    return propStyle;
  }
  render() {
    let selectedColor = this.props.selectedColor;
    const colorOptions = this.props.colorOptions;
    const showSelector = this.state.showSelector;
    if (!selectedColor) {
      selectedColor = colorOptions[0];
    }
    return /*#__PURE__*/React.createElement(Button, this.showModalButtonProps(selectedColor), /*#__PURE__*/React.createElement(Modal, {
      className: "t-csm-modal",
      modalClassName: "wide-modal",
      isOpen: showSelector
    }, /*#__PURE__*/React.createElement(ModalHeader, null, "Select Color"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(ColorSwatches, {
      colorOptions: colorOptions,
      buttonProps: color => this.buttonProps(color)
    })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      className: "t-csm-modal-button-cancel",
      onClick: this.hideModal
    }, "Cancel"))));
  }
}
ColorSelectorModal.defaultProps = {
  // [Red, Yellow, Black, BLue, Yellow, Orange, Purple, Pink, Brown, White]
  colorOptions: ['1 0 0 1', '0.878431 0.878431 0 1', '0 0 0 1', '0 0 1 1', '0 1 0 1', '1 0.5 0 1', '0.5 0 0.5 1', '1 0.6 0.8 1', '0.6 0.4 0.2 1', '1 1 1 1'],
  indicatorShape: 'rectangle',
  disabled: false,
  selectedColor: ''
};
ColorSelectorModal.propTypes = {
  disabled: PropTypes.bool,
  selectedColor: PropTypes.oneOfType(
  // "1 0 0.5 1" or { red: 1, green: 0, blue: 0.5, alpha: 1 }
  [PropTypes.shape({}), PropTypes.string]),
  colorOptions: PropTypes.arrayOf(
  // ["1 0 0.5 1", ...] or [{ red: 1, green: 0, blue: 0.5, alpha: 1 }, ...]
  PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])),
  indicatorShape: PropTypes.string,
  onChange: PropTypes.func.isRequired
};